/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import * as S from "./styles";

export const Button = ({
    color,
    width,
    children,
    onClick,
    secondaryColor,
    onFocusColor,
    onLoading
}) => (
    
    <S.Button
        color={color}
        secondaryColor={secondaryColor}
        width={width}
        onClick={onClick}
        onFocusColor={onFocusColor}
        disabled={onLoading}
    >
     { onLoading === true ? ( <i class="fa fa-spinner fa-spin" style={{marginLeft:"-12px", marginRight:"8px"}}></i> ) : null }
         {children}
    </S.Button>
);



// export default Button;
